import * as actionTypes from '../action-types';
import { toaster } from '../../services/toast-service';
import { select, takeLeading, put } from 'redux-saga/effects';
import { getAPI, postAPI, razorpayPayment } from '../../utils/api-function';
import { get_recharge_service_list, recharge_data, bill_payment, success_recharge, refund_recharge, refund_success_recharge, failed_recharge } from '../../utils/api-routes';

function* getRechargeServiceList() {
    try {
        const { data } = yield getAPI({ key: 'Recharge', url: get_recharge_service_list });
        console.log("Get Recharge Service List Saga Response :::", data);

        if (data?.status == 1) {
            yield put({ type: actionTypes.SET_RECHARGE_SERVICE_LIST, payload: data?.data?.filter(list => list?.service_id != 30 && list?.service_id != 31) });
        } else {
            yield put({ type: actionTypes.SET_RECHARGE_SERVICE_LIST, payload: [] });
        }
    } catch (error) {
        console.log("Get Recharge Service List Saga Error :::", error);
        yield put({ type: actionTypes.SET_RECHARGE_SERVICE_LIST, payload: [] });
    }
};

//! Recharge
function* handleRecharge(action) {
    try {
        const { payload } = action;
        const { number, product_code, product_name, bill_type, amount, latitude, longitude } = payload;
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);

        if (!number) {
            toaster.info({ text: "Please enter number." });
            return;
        }

        if (!amount) {
            toaster.info({ text: "Please select plan or enter recharge amount." });
            return;
        }

        if (!customerDetails) {
            yield put({ type: actionTypes.TOGGLE_LOGIN_MODAL, payload: true })
            return;
        }

        // if (!customerDetails.email || !customerDetails.userid || !customerDetails.mobile || !customerDetails?.firstname || !customerDetails?.pincode) {
        //     toaster.info({ text: "Please update you profile." });
        //     return;
        // }

        const razorpayResponse = yield razorpayPayment({ amount, name: customerDetails?.firstname + ' ' + customerDetails?.lastname, email: customerDetails?.email, contact: customerDetails?.mobile })
        console.log("Razor Pay Response ::: ", razorpayResponse);

        if (razorpayResponse?.status) {
            const { data: rechargeData } = yield postAPI({ key: 'Recharge', url: recharge_data, payload: { number, amount, product_code, customer_number: customerDetails?.mobile, pincode: customerDetails?.pincode || 201301, latitude, longitude, } });
            console.log("Recharge Data Response :: ", rechargeData);

            if (rechargeData?.status == 1) {
                const { data: successRecharge } = yield postAPI({
                    url: success_recharge,
                    payload: {
                        userId: customerDetails?.userid, mobile: customerDetails?.mobile, operatorId: product_code,
                        amount: rechargeData?.amount,
                        number: rechargeData?.number,
                        operator_reference: rechargeData?.operator_reference,
                        razorpayOrderId: razorpayResponse?.result?.razorpay_order_id,
                        rechargeOrderId: rechargeData?.order_id,
                        request_id: rechargeData?.request_id,
                        message: rechargeData?.message,
                        billType: bill_type, productName: product_name,
                    }
                });
                toaster.success({ text: successRecharge?.message });

            } else {
                const { data: refundResponse } = yield postAPI({ url: refund_recharge, payload: { amount, paymentId: razorpayResponse?.result?.razorpay_payment_id } });

                if (refundResponse?.data?.entity == 'refund') {
                    const { data: refund } = yield postAPI({ url: refund_success_recharge, payload: { userId: customerDetails?.userid, number, mobile: customerDetails?.mobile, amount, operatorId: product_code, razorpayOrderId: razorpayResponse?.result?.razorpay_order_id, billType: bill_type, productName: product_name } });
                    toaster.info({ text: refund?.message });
                }
            }

        } else {
            const { data: cancelRecharge } = yield postAPI({ url: failed_recharge, payload: { userId: customerDetails?.userid, number, mobile: customerDetails?.mobile, amount, operatorId: product_code, razorpayOrderId: razorpayResponse?.result?.razorpay_order_id, billType: bill_type, productName: product_name, status: 'CANCEL' } });
            toaster?.error({ text: cancelRecharge?.message || 'Payment Failed.' });
        }

    } catch (error) {
        toaster?.error({ text: 'Payment Failed.' });
    }
};

function* handleBillRecharge(action) {
    try {
        const { payload } = action;
        const { number, product_code, product_name, bill_type, fetched_bill_order_id, amount, latitude, longitude } = payload;
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);

        if (!number) {
            toaster.info({ text: "Please enter number." });
            return;
        }

        if (!amount) {
            toaster.info({ text: "Please select plan or enter recharge amount." });
            return;
        }

        if (!customerDetails) {
            yield put({ type: actionTypes.TOGGLE_LOGIN_MODAL, payload: true })
            return;
        }

        const razorpayResponse = yield razorpayPayment({ amount, name: customerDetails?.firstname + ' ' + customerDetails?.lastname, email: customerDetails?.email, contact: customerDetails?.mobile })
        console.log("Razor Pay Response ::: ", razorpayResponse);

        if (razorpayResponse?.status) {
            const { data: billPayment } = yield postAPI({ key: 'Recharge', url: bill_payment, payload: { number, amount, product_code, customer_number: customerDetails?.mobile, bill_fetch_ref: fetched_bill_order_id, pincode: customerDetails?.pincode || 201301, latitude, longitude, } });

            console.log("Recharge Data Response :: ", billPayment);

            if (billPayment?.status == 1) {
                const { data: successRecharge } = yield postAPI({
                    url: success_recharge,
                    payload: {
                        userId: customerDetails?.userid, mobile: customerDetails?.mobile, operatorId: product_code,
                        amount: billPayment?.amount,
                        number: billPayment?.number,
                        operator_reference: billPayment?.operator_reference,
                        razorpayOrderId: razorpayResponse?.result?.razorpay_order_id,
                        rechargeOrderId: billPayment?.order_id,
                        request_id: billPayment?.request_id,
                        message: billPayment?.message,
                        billType: bill_type, productName: product_name,
                    }
                });
                toaster.success({ text: successRecharge?.message });

            } else {
                const { data: refundResponse } = yield postAPI({ url: refund_recharge, payload: { amount, paymentId: razorpayResponse?.result?.razorpay_payment_id } });

                if (refundResponse?.data?.entity == 'refund') {
                    const { data: refund } = yield postAPI({ url: refund_success_recharge, payload: { userId: customerDetails?.userid, number, mobile: customerDetails?.mobile, amount, operatorId: product_code, razorpayOrderId: razorpayResponse?.result?.razorpay_order_id, billType: bill_type, productName: product_name } });
                    toaster.info({ text: refund?.message });
                }
            }

        } else {
            const { data: cancelRecharge } = yield postAPI({ url: failed_recharge, payload: { userId: customerDetails?.userid, number, mobile: customerDetails?.mobile, amount, operatorId: product_code, razorpayOrderId: razorpayResponse?.result?.razorpay_order_id, billType: bill_type, productName: product_name, status: 'CANCEL' } });
            toaster?.error({ text: cancelRecharge?.message || 'Payment Failed.' });
        }

    } catch (error) {
        toaster?.error({ text: 'Payment Failed.' });
    }
};

export default function* rechargeSaga() {
    yield takeLeading(actionTypes.GET_RECHARGE_SERVICE_LIST, getRechargeServiceList);

    //! Recharge
    yield takeLeading(actionTypes.HANDLE_RECHARGE, handleRecharge);
    yield takeLeading(actionTypes.HANDLE_BILL_RECHARGE, handleBillRecharge);
};